import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { formatMoney } from "../../../features/utils/formatMoney";

function PointsCreateRewardWallet({ data, onChange }) {
  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <CommonFreeTextInput
        value={
          data.pointsCost
            ? `pts ${Number(data.pointsCost).toLocaleString()}`
            : ""
        }
        label="Points Cost"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          onChange({ ...data, pointsCost: numericVal });
        }}
      />
      <CommonFreeTextInput
        value={formatMoney(data.rewardValueInNaira)}
        label="Reward value in naira"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          onChange({ ...data, rewardValueInNaira: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateRewardWallet;
